import ApiClient from "../ApiClient";
import NewUUID from "../../utils/randy/NewUUID";

export const getTracks = async (billId, csrfToken) => {
    const response = await ApiClient.get(`/api/bills/templates/${billId}/participants`, {
        headers: {
            accept: "application/json",
            request_id: NewUUID(),
            "X-CSRF-Token": csrfToken
        },
    });
    return response.data.result || [];
};

export const createTrack = async (billId, trackIndex, userId, csrfToken) => {
    const body = {};
    if (trackIndex !== null && trackIndex !== undefined) {
        body.track_index = trackIndex;
    }
    if (userId) {
        body.user_id = userId;
    }
    
    const response = await ApiClient.post(`/api/bills/templates/${billId}/tracks`, body, {
        headers: {
            accept: "application/json",
            request_id: NewUUID(),
            "X-CSRF-Token": csrfToken
        },
    });
    return response.data.result;
};

export const updateTrack = async (billId, trackId, userId, csrfToken) => {
    const body = {};
    if (userId) {
        body.user_id = userId;
    } else {
        body.user_id = null; // Set to vacancy
    }
    
    const response = await ApiClient.put(`/api/bills/templates/${billId}/tracks/${trackId}`, body, {
        headers: {
            accept: "application/json",
            request_id: NewUUID(),
            "X-CSRF-Token": csrfToken
        },
    });
    return response.data.result;
};

export const swapTracks = async (billId, trackIndex1, trackIndex2, csrfToken) => {
    const response = await ApiClient.post(`/api/bills/templates/${billId}/tracks/swap`, {
        track_index1: trackIndex1,
        track_index2: trackIndex2,
    }, {
        headers: {
            accept: "application/json",
            request_id: NewUUID(),
            "X-CSRF-Token": csrfToken
        },
    });
    return response.data.result;
};

export const deleteTrack = async (billId, trackId, csrfToken) => {
    const response = await ApiClient.delete(`/api/bills/templates/${billId}/tracks/${trackId}`, {
        headers: {
            accept: "application/json",
            request_id: NewUUID(),
            "X-CSRF-Token": csrfToken
        },
    });
    return response.data.result;
};
